import React from 'react';
import ReactDOM from 'react-dom/client';
import { Toaster } from 'react-hot-toast';
import { Provider } from 'react-redux';
import App from './App';
import './index.css';
import reportWebVitals from './reportWebVitals';
import store from './store';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <Provider store={store}>
    <App />
    <Toaster
          toastOptions={{
            position: 'top-center',
            style:  {
              background: 'linear-gradient(to right, #ff0000, #0000ff)',
              color:  '#ffff',
            }
          }}
        />
  </Provider>
);


reportWebVitals();
